import { render } from "./OverviewContactBlock.vue?vue&type=template&id=b5535490&scoped=true"
import script from "./OverviewContactBlock.vue?vue&type=script&lang=js"
export * from "./OverviewContactBlock.vue?vue&type=script&lang=js"

import "./OverviewContactBlock.vue?vue&type=style&index=0&id=b5535490&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5535490"]])

export default __exports__